<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item ref="query" :model="query">
          <el-input placeholder="请输入快递名称 / 快递编号" v-model="query.key" @keyup.enter.native="getList"
            @change="ischange = true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" icon="el-icon-circle-plus-outline" @click="addexpressinfo">新增</el-button>
        </el-form-item>
        <el-form-item v-if="versionId != '13'">
          <el-button @click="batchsetexpressstatus">批量设置启用状态</el-button>
        </el-form-item>
      </el-form>
      <el-tag type="danger" size="small" style="margin-top:10px">注：线上启用快递为线上商城配送区域设置快递配送费时可启用该快递信息</el-tag>

      <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" ref="tabelRef" v-loading="listLoading" size="mini">
          <!-- 多选 -->
          <el-table-column type="selection" width="55" align="center" v-if="versionId != '13'"></el-table-column>
          <el-table-column label="ID" prop="id" align="left" v-if="versionId != '13'" width="70"></el-table-column>
          <el-table-column label="快递公司" prop="name" align="left"></el-table-column>
          <el-table-column label="快递编号" prop="number" width="150" align="center"></el-table-column>
          <el-table-column label="客户编号/月结卡号" prop="customer_name" align="left"
            v-if="versionId != '13'"></el-table-column>
          <el-table-column label="寄件人地址" prop="address" align="left" v-if="versionId != '13'" width="350">
            <template slot-scope="scope">
              {{ scope.row.province_name }}{{ scope.row.city_name}}{{ scope.row.area_name }}{{ scope.row.address }}
            </template>
          </el-table-column>
          <el-table-column label="联系人" prop="contacts_name" align="left" v-if="versionId != '13'"></el-table-column>
          <el-table-column label="联系电话" prop="contacts_phone" align="left" v-if="versionId != '13'"></el-table-column>
          <el-table-column label="启用" prop="is_normal" align="left" v-if="versionId != '13'" width="80">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_normal" size="mini" active-color="#13ce66" inactive-color="#ff4949"
                :active-value="'1'" :inactive-value="'0'" @change="changeexpressstatus(scope.row)">
              </el-switch>
            </template>>
          </el-table-column>
          <el-table-column label="操作" width="230" align="center">
            <template slot-scope="scope">
              <!-- 点击面单模板，弹出一个弹窗，显示面单模板图片 -->
              <!-- <el-button type="text" @click="openTemplate(scope.row)" v-if="versionId != '13'">面单模板</el-button> -->
              <el-button type="text" @click="editcurrent(scope.row)" v-if="versionId != '13'">编辑</el-button>
              <el-button type="text" @click="delcurrent(scope.row)">删除</el-button>
              <el-button type="text" @click="openmall(scope.row)">快递费设置</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange" :current-page="query.p"
            :page-sizes="[10, 20, 50]" :page-size="query.rollpage" layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <el-dialog :visible.sync="templateDialog" title="面单样式"" width=" 400px" @close="templateDialog = false">
        <img :src="templateUrl" style="width:100%;">
      </el-dialog>

      <el-dialog title="新增/快递信息" :visible.sync="addexpressDialog" top="15vh" width="40%" :destroy-on-close="true">
        <el-form :model="addexpress" :rules="rules" ref="addexpressForm" label-width="140px">
          <el-form-item label="寄件省市区：" prop="province" v-if="versionId != '13'">
            <el-cascader v-model="addexpress.province" :options="cityList" :props="{ value: 'id', label: 'name' }"
              @change="handleCityChange" style="width: 100%;"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address" v-if="versionId != '13'">
            <el-input placeholder="请输入详细地址" v-model="addexpress.address" style="width: 100%;"></el-input>
          </el-form-item>
          <el-form-item label="快递公司：" prop="logistics_id" style="width:100%">
            <el-select v-model="addexpress.logistics_id" clearable remote filterable placeholder="选择快递信息"
              style="width: 100%;">
              <el-option v-for="(item, index) in shippinglists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-row v-if="versionId != '13'" :gutter="20">
            <el-col :span="12">
              <el-form-item label="客户编号：" prop="customer_name">
                <el-input placeholder="请输入" v-model="addexpress.customer_name" style="width: 100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密钥：" prop="customer_pwd">
                <el-input placeholder="请输入" v-model="addexpress.customer_pwd" style="width: 100%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="联系人姓名：" prop="contacts_name" v-if="versionId != '13'">
            <el-input placeholder="请输入" v-model="addexpress.contacts_name" style="width: 100%;"></el-input>
          </el-form-item>
          <el-form-item label="联系人手机：" prop="contacts_phone" v-if="versionId != '13'">
            <el-input placeholder="请输入" v-model="addexpress.contacts_phone" style="width: 100%;"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="addexpressDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="updateLoading" @click="submitForm('addexpressForm')">保
            存</el-button>
        </div>
      </el-dialog>


      <!-- 匹配线上商城快递信息 -->
      <el-dialog title="快递费用信息设置" :visible.sync="settingLogisticsDialog" top="15vh" width="25%">
        <div class="express-setting">
          <el-form :inline="true" class="demo-form-inline" size="small">
            <el-form-item label-width="100" label="快递名称：" style="width:100%">
              <template>
                <span>{{ setmallquery.name }}</span>
              </template>
            </el-form-item>
            <!--
              <el-form-item label-width="100" label="是否开启：" style="width:100%">
                  <el-switch v-model="setmallquery.ismall" active-color="#13ce66" inactive-color="#C0C4CC"></el-switch>
              </el-form-item>
              <el-form-item label-width="100" label="匹配快递：" style="width:100%">
					<el-select v-model="setmallquery.logisticsid" clearable remote  filterable placeholder="选择匹配第三方的快递信息">	            
						<el-option v-for="(item,index) in shippinglists" :label="item.showlable" :value="item.id" :key="index">
							<span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						</el-option>              
					</el-select>          
			  </el-form-item>
              -->
            <el-form-item label-width="100" label="首重重量：" style="width:100%">
              <el-input placeholder="请输入首重重量" v-model="setmallquery.startweight" clearable><template
                  slot="append">kg</template></el-input>
            </el-form-item>
            <el-form-item label-width="100" label="首重金额：" style="width:100%">
              <el-input placeholder="请输入首重金额" v-model="setmallquery.startprice" clearable><template
                  slot="prepend">￥</template></el-input>
            </el-form-item>
            <el-form-item label-width="100" label="续重重量：" style="width:100%">
              <el-input placeholder="请输入续重重量" v-model="setmallquery.againweight" clearable><template
                  slot="append">kg</template></el-input>
            </el-form-item>
            <el-form-item label-width="100" label="续重金额：" style="width:100%">
              <el-input placeholder="请输入续重金额" v-model="setmallquery.againprice" clearable><template
                  slot="prepend">￥</template></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="settingLogisticsDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="saveexpresssetting">保 存</el-button>
        </div>
      </el-dialog>


    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      cityList: [],
      versionId: '',
      actionauth: '', //操作功能权限
      transitionshow: true,
      url: this.GLOBAL.domain + "Express/index",
      listLoading: false,
      lists: [],
      total_rows: 0,
      ischange: false,
      ismalllists: [
        { id: 1, name: '非线上启用快递' },
        { id: 2, name: '线上启用快递' }
      ],
      query: {
        act: 'lists',
        token: this.$cookies.get('token'),
        ismall: '',
        key: '',
        p: 1,
        rollpage: 10
      },
      addexpressDialog: false,
      updateLoading: false,
      addexpress: {
        province: [],
        province_id: '', //省id
        city_id: '', //市id
        area_id: '', //区id
        address: '', //详细地址
        customer_name: '', // 客户编号
        customer_pwd: '', // 秘钥
        contacts_name: '', // 联系人姓名
        contacts_phone: '', // 联系电话
        act: 'addexpress',
        token: this.$cookies.get('token'),
        logistics_id: '',
        thumb: '',
        showthumb: '',
        name: '',
        number: '',
      },
      expressthumb: {
        id: '',
        index: '',
      },
      settingLogisticsDialog: false,
      shippinglists: [],
      setmallquery: {
        act: 'saveismall',
        token: this.$cookies.get('token'),
        id: '',
        name: '',
        logisticsid: '',
        number: '',
        ismall: '',
        startweight: '',
        startprice: '',
        againweight: '',
        againprice: '',
      },
      templateDialog: false,
      templateUrl: 'https://www.234f.com/d/file/downloads/express/2014-08-31/08a0eb7bb04b66674edc38a66250f882.jpg',
      rules: {
        province: [
          { required: true, message: '请选择寄件省份', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        logistics_id: [
          { required: true, message: '请选择快递公司', trigger: 'change' }
        ],
        customer_name: [
          { required: true, message: '请输入客户编号', trigger: 'blur' }
        ],
        customer_pwd: [
          { required: true, message: '请输入密钥', trigger: 'blur' }
        ],
        contacts_name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contacts_phone: [
          { required: true, message: '请输入联系人手机', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },

    }
  },
  created() {
    const id = localStorage.getItem('version_id');
    this.versionId = id
    this.$axios({
      url: '/Express/index',
      method: 'POST',
      data: {
        act: 'get_city_info'
      }
    })
      .then(res => {
        this.cityList = res.Data
      })
  },
  mounted() {
    this.getactionauth();
    this.getList();
    //获取所有物流快递信息
    this.getallshippinglists();
  },
  methods: {
    handleCityChange(val) {
      console.log(val)
    },
    batchsetexpressstatus() {
      this.$confirm('请选择启用或禁用快递信息', '提示', {
        confirmButtonText: '启用',
        cancelButtonText: '禁用',
        type: 'warning'
      }).then(() => {
        // 用户点击启用按钮的逻辑
        this.updateExpressStatus('1');
      }).catch(() => {
        // 用户点击禁用按钮的逻辑
        this.updateExpressStatus('0');
      });
    },
    updateExpressStatus(status) {
      const selectedRows = this.$refs.tabelRef.selection;
      if (selectedRows.length === 0) {
        this.$message.warning('请先选择要操作的快递信息');
        return;
      }
      const ids = selectedRows.map(row => row.id).join(',');
      this.$axios({
        url: '/Express/index',
        method: 'POST',
        data: {
          act: 'update_express',
          id: ids,
          is_normal: status
        }
      })
        .then(res => {
          this.$message.success('更新成功!');
          this.getList();
        })
        .catch(err => {
          this.$message.error('更新失败!');
        });
    },
    changeexpressstatus(row,) {
      console.log(row.is_normal, '==========')
      this.$axios({
        url: '/Express/index',
        method: 'POST',
        data: {
          act: 'update_express',
          id: row.id,
          is_normal: row.is_normal
        }
      })
        .then(res => {
          this.$message.success('更新成功!');
        })
    },
    editcurrent(item) {
      this.addexpressDialog = true;
      this.$nextTick(() => {
        this.addexpress = {
          ...this.addexpress, // 保留原有属性
          logistics_id: item.logistics_id,
          id: item.id,
          thumb: item.thumb,
          showthumb: item.showthumb,
          name: item.name,
          number: item.number,
          province: [item.province_id, item.city_id, item.area_id],
          address: item.address,
          customer_name: item.customer_name,
          customer_pwd: item.customer_pwd,
          contacts_name: item.contacts_name,
          contacts_phone: item.contacts_phone,
        };
      });

    },
    openTemplate(row) {
      this.templateDialog = true
    },
    /** 删除快递信息 **/
    delcurrent(item) {
      this.$confirm('此操作将永久删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {

        var resource = this.$resource(this.url);
        resource.save({ act: 'delexpress', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + item.name + '!');
            this.getList();
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });

      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },

    // /** 编辑快递信息 **/
    // editcurrent(item) {
    //   this.addexpressDialog = true;
    //   this.addexpress.logistics_id = item.id;
    //   this.addexpress.thumb = item.thumb;
    //   this.addexpress.showthumb = item.showthumb;
    //   this.addexpress.name = item.name;
    //   this.addexpress.number = item.number;
    // },

    /** 编辑图片信息 **/
    editbrandimg(id, index) {
      this.expressthumb.id = id;
      this.expressthumb.index = index;
      document.getElementById('express_file').click();
    },

    /** 上传快递logo图片 **/
    fileChange(el) {
      var resource = this.$resource(this.GLOBAL.uploadUrl);
      for (let i = 0; i < el.target.files.length; i++) {
        var formData = new FormData();
        formData.append('file', el.target.files[i]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
        resource.save(formData).then((res) => {
          var data = JSON.parse(Base64.decode(res.body.Data));
          if (data.Result > 0) {
            this.$message.error(data.msg);
          } else {
            this.lists[this.expressthumb.index].thumb = data.imgsrc;
            this.lists[this.expressthumb.index].showthumb = this.GLOBAL.staticUrl + data.imgsrc;
            this.editimgs(data.imgsrc);
            el.target.value = '';
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
        });
      }
    },

    /** 将图片信息保存到服务器 **/
    editimgs(img) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'editimg', id: this.expressthumb.id, thumb: img, token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {

        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 新增快递信息 **/
    addexpressinfo() {
      this.addexpress = {
        province: [],
        province_id: '', //省id
        province_name: '', //省
        city_id: '', //市id
        city_name: '', //市
        area_id: '', //区id
        area_name: '', //区
        address: '', //详细地址
        customer_name: '', // 客户编号
        customer_pwd: '', // 秘钥
        contacts_name: '', // 联系人姓名
        contacts_phone: '', // 联系电话
        act: 'addexpress',
        token: this.$cookies.get('token'),
        logistics_id: '',
        thumb: '',
        showthumb: '',
        name: '',
        number: '',
      };
      this.$nextTick(() => {
        this.addexpressDialog = true;
        if (this.$refs.addexpressForm) {
          this.$refs.addexpressForm.resetFields();
        }
      });
    },
    // 根据省市区获取中文名称
    getProvinceName(province) {
      if (province.length > 0) {
        // 找到目标省份
        const targetProvince = this.cityList.find(item => item.id === province[0]);
        // 找到目标市
        const targetCity = targetProvince.children.find(item => item.id === province[1]);
        // 找到目标区
        const targetArea = targetCity.children.find(item => item.id === province[2]);
        
        this.addexpress.province_name = targetProvince.name;
        this.addexpress.city_name = targetCity.name;
        this.addexpress.area_name = targetArea.name;
      }
    },

    /** 新增/编辑快递公司信息 **/
    saveexpress() {
      this.updateLoading = true;
      this.getProvinceName(this.addexpress.province)
      const data = JSON.parse(JSON.stringify(this.addexpress))
      data.province_id = data.province[0]
      data.city_id = data.province[1]
      data.area_id = data.province[2]

      // 如果data.id存在则执行更新的接口，否则执行新增的接口
      if (data.id) {
        this.$axios({
          url: '/Express/index',
          method: 'POST',
          data: {
            ...data,
            act: 'editexpress',
            id: data.id
          }
        })
          .then(res => {
            this.$message.success('更新成功!');
            this.getList();
            this.addexpressDialog = false;
          })
          .finally(() => {
            this.updateLoading = false;
          });
      } else {
        this.$axios({
          url: '/Express/index',
          method: 'POST',
          data: {
            ...data,
            act: 'addexpress'
          }
        })
          .then(res => {
            this.$message.success('添加成功!');
            this.getList();
            this.addexpressDialog = false;
          })
          .finally(() => {
            this.updateLoading = false;
          });
      }

      // resource.save(data).then((res) => {
      //   if (res.data.Result > 0) {
      //     if (res.data.Result == '70001') this.$router.push('/login')
      //     this.$message.error(res.data.Message);
      //     this.updateLoading = false;
      //   } else {
      //     this.getList();
      //     this.updateLoading = false;
      //     this.addexpressDialog = false;
      //   }
      // }).catch((res) => {
      //   this.updateLoading = false;
      // });
    },

    /** 获取快递信息 **/
    getList() {
      this.listLoading = true;
      if (this.ischange == true) {
        this.query.p = 1;
        this.query.rollpage = 10;
      }

      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows = parseInt(res.data.count);
          this.listLoading = false;
          if (this.ischange == true) this.ischange = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },
    pageSizeChange(val) {
      this.query.rollpage = val;
      this.getList();
    },
    pageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },


    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    //重置表单
    reset() {
      this.$refs.create.resetFields();
    },

    /** 开启线上商城启用快递模板 **/
    openmall(obj) {
      this.settingLogisticsDialog = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getexpressinfos', token: this.$cookies.get('token'), id: obj.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.setmallquery.id = result.id;
          this.setmallquery.name = result.name;
          this.setmallquery.id = result.id;
          this.setmallquery.name = result.name;
          this.setmallquery.logisticsid = result.logistics_id == 0 ? '' : result.logistics_id;
          this.setmallquery.number = result.number;
          this.setmallquery.ismall = result.ismall == 0 ? false : true;
          this.setmallquery.startweight = result.startweight;
          this.setmallquery.startprice = result.startprice;
          this.setmallquery.againprice = result.againprice;
          this.setmallquery.againweight = result.againweight;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    //获取所有快递物流信息
    getallshippinglists() {
      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.query({ act: 'getallshippinglists', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.shippinglists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {

      });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveexpress();
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    /** 保存设置的快递信息 **/
    saveexpresssetting() {
      this.$confirm('警告：如该快递模板已被线上启用，关闭则会同步删除相应的快递模板对应的运费设置，您是否确认要保存该设置 ？', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.query(this.setmallquery).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.settingLogisticsDialog = false;
            this.getList();
          }
        }).catch((res) => {

        });

      }).catch(() => {

      });

    },


  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}

.editbrand-express {
  float: left;
  width: 100%;
  border-radius: 5px;
  cursor: pointer
}

.editbrand-express:hover {
  opacity: 1;
  filter: alpha(opacity=100);
}

.express-setting .el-form-item__content {
  width: 60%
}

.express-warning {
  padding: 5px;
  border-radius: 5px;
  background-color: rgb(192, 196, 204, .4);
  border: 1px solid rgb(192, 196, 204, .1);
  color: #f56c6c;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px
}
</style>


// WEBPACK FOOTER //
// src/components/base/Express.vue